import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = { id: "login-screen" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"Logo\" class=\"centered-logo\"><div class=\"logo-button-spacer\"></div><div class=\"signin-container\"><div id=\"g_id_onload\" data-auto_prompt=\"false\"></div><div class=\"g_id_signin\" data-type=\"standard\"></div></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}